<template>
    <p-feature-flag
        name="Non Merch"
        redirect>
        <p-form @submit="onSubmit">
            <div class="container-fluid content-wrapper" v-if="nonMerch">
                <b-row class="content-heading">
                    <b-col>
                        <div>{{ isNew ? 'Add' : 'Edit' }} Non Merch</div>
                    </b-col>
                    <b-col class="text-end">
                        <p-button type="submit" :is-busy="isBusy" variant="primary">Save</p-button>
                    </b-col>
                </b-row>
                <p-card>
                    <b-row cols="1" cols-sm="2" cols-xl="3">
                        <b-col>
                            <p-input
                                label="Name"
                                v-model="nonMerch.name"
                                rules="required|max:50" />
                        </b-col>
                    </b-row>

                    <b-row cols="1" cols-sm="2" cols-xl="3">
                        <b-col>
                            <p-select
                                data-type="taxItems"
                                v-model="nonMerch.taxItemId"
                                label="Tax Type"
                                rules="required" />
                        </b-col>
                    </b-row>                         

                    <b-row cols="1" cols-sm="2" cols-xl="3">
                        <b-col>
                            <p-number
                                label="Price"
                                v-model="nonMerch.price"
                                input-type="money"
                                left-align />
                        </b-col>
                    </b-row>

                    <b-row cols="1" cols-sm="2" cols-xl="3" class="mt-3">
                        <b-col>
                            <p-checkbox
                                label="Is Discount Allowed"
                                v-model="nonMerch.allowDiscounts" />
                        </b-col>
                    </b-row>

                    <b-row cols="1" cols-sm="2" cols-xl="3">
                        <b-col>
                            <p-checkbox
                                label="Is Refundable"
                                v-model="nonMerch.isRefundable" />
                        </b-col>
                    </b-row>

                    <b-row cols="1" cols-sm="2" cols-xl="3">
                        <b-col>
                            <p-checkbox
                                label="Active"
                                :use-switch="true"
                                class="mt-3 pt-3 mb-3 pb-3 ms-3"
                                v-model="nonMerch.isActive"
                            />
                        </b-col>
                    </b-row>
                </p-card>

                <b-row>
                    <b-col cols="12">
                        <p-feature-flag ref="AccountingFlag" name="Accounting">
                        <p-card>
                            <b-row>
                            <b-col cols="12">
                                <GlCodeNonMerch
                                :items="this.nonMerch.nonMerchChartOfAccountsTypes"
                                :fields="fields" />
                            </b-col>   
                            </b-row>
                        </p-card>
                        </p-feature-flag>
                    </b-col>
                </b-row>
                            
                <b-row class="mt-4">
                    <b-col class="text-center mb-3">
                        <p-button
                            variant="primary"
                            type="submit"
                            :is-busy="isBusy"
                            class="text-end"
                            >Save</p-button
                        >
                    </b-col>
                </b-row>
            </div>
        </p-form>
    </p-feature-flag>
</template>

<script>
import axios from "axios";
import NavigationGuard from '@/components/mixins/NavigationGuard.js'
import editPage from '@/components/mixins/EditPage';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import GlCodeNonMerch from '@/components/GLCodeNonMerch';

export default {
    mixins: [NavigationGuard, editPage],
    components: {
        GlCodeNonMerch
    },    
    data() {
        return {
            nonMerch: null,
            isBusy: false,
            fields:[
                {
                    key: 'chartOfAccountsTypeDescription',
                    label: '',
                },
                {
                    key: 'glCode',
                    label: 'GL Code',
                }
            ]
        };
    },
    watch: {
        nonMerch: NavigationGuard.$watcher,
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        }
    },
    computed: {
        isNew() {
            return this.id === 'new';
        }
    },
    methods: {
        async onSubmit() {
            let locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            if(this.nonMerch.locationId != locationId && this.nonMerch.specialItemId > 0) {
                this.$bvModal.msgBoxConfirm(`Are you sure you wish to create a new Non Merch record '${this.nonMerch.name}' for the currently selected location?`)
                .then(value => {
                    if (value) {
                        this.nonMerch.locationId = locationId;
                        this.saveData();
                    }
                });
            }
            else {
                this.saveData();
            }
        },
        async loadData() {
            let promise = this.isNew
                ? axios.get('nonmerch/new')
                : axios.get('nonmerch', { params: { id: this.id } });

            promise.then(async resp => {
                this.nonMerch = resp.data;

                if (this.isNew) {
                    this.nonMerch.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
                }
                else {
                    this.dataLoaded();
                }
            });
        },
        async saveData() {
            this.isBusy = true;
            axios.post("nonmerch", this.nonMerch)
                .then((response) => {
                    this.dataSaved();
                    if (this.isNew) {
                        this.$router.push("/nonmerch/" + response.data);
                    }
                    this.$appSuccess(`Non Merch '${this.nonMerch.name}' saved successfully.`);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }      
    },
    mounted: function() {
        this.loadData();
    }
};
</script>